import React from 'react';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { withSnackbar } from 'notistack';

import { auth, firebase, db } from '../firebase';

const INITIAL_STATE = {
  email: '',
  fullname: '',
  password: '',
  repassword: '',
  error: null
};

class AstrologerForm extends React.Component {
  constructor(props) {
    super(props)
    this.handleChange = this.handleChange.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
    this.state = {
      ...INITIAL_STATE
    }
  }

  handleChange(event) {
    this.setState({[event.target.name] : event.target.value})
  }

  handleSubmit() {
    const {
      email, fullname, password, repassword
    } = this.state
    if(!this.validateEmail(email)) {
      this.setState({error: "Badly formatted email"})
      return
    } else if(password !== repassword) {
      this.setState({error: "Passwords do not match"})
      return
    } else {
      this.setState({error: null})
      var createUser = firebase.functions.httpsCallable('createUser');
      createUser({email: email, password: password, fullname: fullname}).then(result => {
        const success = result.data.success
        if(success) {
          const uid = result.data.user.uid
          const fullName = result.data.user.displayName
          db.ref('Admins').child(uid).set({
            email: email,
            super: false,
            fullname: fullName
          }).then(user => {
            this.setState({...INITIAL_STATE})
            this.props.enqueueSnackbar('Successfully Added Astrologer')
          }).catch(error => {
            this.setState({error: error.message})
          })
        }
      }).catch(error => {
        this.setState({error: error.message})
      })
    }
  }

 
  validateEmail(email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
  }

  render() {
    const {
      email, fullname, password, repassword, error
    } = this.state
    const isInvalid = email === '' || fullname === '' || password === '' || repassword === ''
    return (
      <div>
        <Dialog
          open={this.props.open}
          onClose={this.handleClose}
          aria-labelledby="form-dialog-title"
        >
          <DialogTitle id="form-dialog-title">Add new Astrologer</DialogTitle>
          <DialogContent>
            <DialogContentText>
              To add new astrologer, please enter your email address here. The astrologer then can respond to the user questions.
            </DialogContentText>
            <TextField
              autoFocus
              margin="dense"
              name="email"
              label="Email Address"
              type="text"
              fullWidth
              required={true}
              onChange= {(e) => this.handleChange(e)}
              value={email}
            />
            <TextField
              margin="dense"
              name="fullname"
              label="Full Name"
              type="text"
              fullWidth
              required={true}
              onChange= {(e) => this.handleChange(e)}
              value={fullname}
            />
            <TextField
              margin="dense"
              name="password"
              label="Password"
              type="password"
              fullWidth
              required={true}
              onChange= {(e) => this.handleChange(e)}
              value={password}
            />
            <TextField
              margin="dense"
              name="repassword"
              label="Confirm Password"
              type="password"
              fullWidth
              required={true}
              onChange= {(e) => this.handleChange(e)}
              value={repassword}
            />
            {error && <p>{error}</p>}

          </DialogContent>
          <DialogActions>
            <Button onClick={this.props.handleFormClose} color="primary">
              Cancel
            </Button>
            <Button color="secondary" disabled={isInvalid} onClick={this.handleSubmit}>
              Add Astrologer
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

export default withSnackbar(AstrologerForm)


// WEBPACK FOOTER //
// ./src/Components/AstrologerForm.js